import HelpIcon from '@mui/icons-material/Help';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import SearchIcon from '@mui/icons-material/Search';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import PhonelinkLockIcon from '@mui/icons-material/PhonelinkLock';
import FilterListIcon from '@mui/icons-material/FilterList';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import CreateIcon from '@mui/icons-material/Create';
import PublishIcon from '@mui/icons-material/Publish';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import SubjectIcon from '@mui/icons-material/Subject';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import CloseIcon from '@mui/icons-material/Close';
import GetAppIcon from '@mui/icons-material/GetApp';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import InfoIcon from '@mui/icons-material/Info';
import DeleteIcon from '@mui/icons-material/Delete';
import LensIcon from '@mui/icons-material/Lens';
import LensOutlinedIcon from '@mui/icons-material/LensOutlined';
import BatteryCharging90Icon from '@mui/icons-material/BatteryCharging90';
import ScheduleIcon from '@mui/icons-material/Schedule';
import DoneIcon from '@mui/icons-material/Done';
import AddIcon from '@mui/icons-material/Add';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import Icon from '@mui/material/Icon';
import React from 'react';


/**
 * @param {string} name
 * @param {boolean} [useDefaultIcon]
 * @param {Object} [props]
 * @return {JSX.Element}
 */
export function getIcon(name, useDefaultIcon = true, props = {} ) {
    switch (name) {
    case 'KeyboardArrowDown': return (<KeyboardArrowDownIcon {...props}/>);
    case 'LocationOnOutlined': return (<LocationOnOutlinedIcon {...props}/>);
    case 'AttachMoney': return (<AttachMoneyIcon {...props}/>);
    case 'Search': return (<SearchIcon {...props}/>);
    case 'PersonOutline': return (<PersonOutlineIcon {...props}/>);
    case 'DescriptionOutlined': return (<DescriptionOutlinedIcon {...props}/>);
    case 'CancelOutlined': return (<CancelOutlinedIcon {...props}/>);
    case 'PhonelinkLock': return (<PhonelinkLockIcon {...props}/>);
    case 'FilterList': return (<FilterListIcon {...props}/>);
    case 'ArrowBack': return (<ArrowBackIcon {...props}/>);
    case 'ArrowForward': return (<ArrowForwardIcon {...props}/>);
    case 'Create': return (<CreateIcon {...props}/>);
    case 'Publish': return (<PublishIcon {...props}/>);
    case 'CheckBoxOutlineBlank': return (<CheckBoxOutlineBlankIcon {...props}/>);
    case 'CheckBox': return (<CheckBoxIcon {...props}/>);
    case 'ExpandMore': return (<ExpandMoreIcon {...props}/>);
    case 'ExpandLess': return (<ExpandLessIcon {...props}/>);
    case 'ReportProblemOutlined': return (<ReportProblemOutlinedIcon {...props}/>);
    case 'Edit': return (<EditIcon {...props}/>);
    case 'Save': return (<SaveIcon {...props}/>);
    case 'ErrorOutline': return (<ErrorOutlineIcon {...props}/>);
    case 'Subject': return (<SubjectIcon {...props}/>);
    case 'CheckCircleOutline': return (<CheckCircleOutlineIcon {...props}/>);
    case 'RadioButtonUnchecked': return (<RadioButtonUncheckedIcon {...props}/>);
    case 'Close': return (<CloseIcon {...props}/>);
    case 'Export': return (<GetAppIcon {...props}/>);
    case 'Risk': return (<ReportProblemIcon {...props}/>);
    case 'Info': return (<InfoIcon {...props}/>);
    case 'Delete': return (<DeleteIcon {...props}/>);
    case 'LensIcon': return (<LensIcon {...props}/>);
    case 'LensOutlinedIcon': return (<LensOutlinedIcon {...props}/>);
    case 'BatteryCharging90Icon': return (<BatteryCharging90Icon {...props}/>);
    case 'ScheduleIcon': return (<ScheduleIcon {...props}/>);
    case 'DoneIcon': return (<DoneIcon {...props}/>);
    case 'AddIcon': return(<AddIcon {...props}/>);
    case 'CheckCircleIcon': return (<CheckCircleIcon {...props}/>);
    case 'ErrorIcon': return (<ErrorIcon {...props}/>);
    case 'QualityIcon': return (<Icon {...props} >Q</Icon>);
    default: return useDefaultIcon ? (<HelpIcon {...props}/>) : null;
    }
}
